import { Injectable } from '@angular/core'
import { HttpGeneralService } from '../../shared/shared';
import { CashierParms, PatientParms, StockModuleSettingsParms } from '../../shared/search-params';
import { CshCashierTransCheque } from '../cheque-detail/cheque-detail.component';
import { CshCashierTransVisa } from '../visa-detail/visa-detail.component';
import { CshDeductionsDetails } from '../deductions-details';
import { InOutVariable } from '../inOutVariables';
import { CONFIG } from '../../shared/config';
import { ApprovalRequest } from '../../approvals';
import { TherapeuticCards } from '../../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { ClaimsMemo } from '../../claims/claims-memos/claims-memos';
import { CshCashierTransCoupon } from '../coupon-detail/coupon-detail.component';
import { RegPatService } from '../../pricing/reg-pat-service/reg-pat-service';
import { BankTransformer, cshBankTransformerLog } from '../../banks/Bank-Transformer/bank-transformer.service';
import { ApprovalRequestMaster } from '../../approvals/approvals-list/approvals-list.service';
import { BranchStp } from '../../hospitalSetup/gen_branches_stp/gen_branches_stp.service';
import { CshSettlement } from '../another-settlement/cshSettlements';
import { GenModuleSettingService } from '../../shared/gen-module-setting.service';
let cashiertransUrl = CONFIG.baseUrls.cashierTrans;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
let orderingUrl = CONFIG.baseUrls.ordering;
export interface CashierTrans {
  serial: number;
  transType: number;
  transDate: Date;
  transDateNgb: any;
  settlmentLoyaltyPoint:number;
  benfCode: number;
  benfType: number;
  memoCode?: number;
  advancePaymentSerial?: number;
  cshDownPaymentsSerialOfEmployeeCustody?: number;
  visitSerial: number;
  cashAmmount: number;
  chequeAmmount: number;
  visaAmmount: number;
  couponAmmount: number;
  total?: number;
  purchasePrice?: number;
  totalAdvancePayment: number;
  settleAdvancePayment: number;
  settleBankTransformer: number;
  settleOutGoingBankTransfer: number;
  netAdvancePayment: number;
  cashierId: number;
  cshCurrencyCode: number;
  cshCurrencyFactor: number;
  parentReceipt?: number;
  discountType?: number;
  percentOrValue?: number;
  discountValue?: number;
  cshDiscountsCode?: number;
  cancelReceiptNumber?: number;
  returnSecLoginId?: number;
  cshCancelationReasonsCode?: number;
  cancelationNotes: string;
  cshBankStpCode?: number;
  totalDeductions?: number;
  billSummaryPatBillSerial?: number;
  visitDownPayment?: number;
  permissionSerial?: number;
  // extended properties
  cshNameAr: string;
  cshNameEn: string;
  regSecLoginId: number;
  payRollMonth?: number;
  loanTermsSerials?: string;
  notes?: string;
  SupplierDiscountNotificationValue?: number;
  cashierBenfSecLogin?: number;
  handReceipt?: number;
  stockTransSerial?: number;
  study_ID?: number;
  cancelReqEmpNameAr?: string;
  cancelReqEmpNameEn?: string;
  vatRegNo?: string;
  vatMoneyValue?: number;
  vatPercent?: number;
  pricIncludeVatFlag?: number;
  priceBeforDiscount?: number;
  tranferToCashier?: number;
  cancelInpatientReciptFlag: string;
  selected?: number;
  ngbFromDateStr?: Date,
  ngbToDateStr?: Date,
  payrollType?: number,
  hrSalItem?: number;
  contractId?: number;
  settelBanktransferSader?: number;
  settelBanktransferWard?: number;
  dollarRate?: number;
  shortageReceiptSerial?: number;
  cancelReceiptService?: number;
  anotherSettlement?: number;
  memoDoc?: number;
  notifCode?: number;
  totalMemosValue?: number;
  depositPermissionRequestSerial?: number;
  memoNotes?: string
}


export interface Total {
  totalPrice: number;
  totalNetPrice: number;
  totalPatPrice: number;
  totalAfterDiscount: number;
  totalPayedValue: number;
  totalWantedValue: number;
  totalSharedPrice: number;
  totalRemainingPrice: number;
  totalPaid: number;
  totalSharedVat?: number;
  totalPatVat?: number;
  totalDiscount?: number
  totalLastPayed?: number;
  totalCount?: number
  totalDisplaySharedPrice?: number;
}

export interface payRollValidation {
  payrollType?: number,
  hrSalItem?: number,
  payRollMonth?: number;
  payRollYear?: number;


}

export interface PayedServices {
  serial?: number;
  type?: number;
  payed?: number;
  payedValue?: number;
  remainingPrice?: number;
  discountValue?: number;
  percentOrValue?: number;
  disVal?: number;
  price?: number;
  patPrice?: number;
  sharedPrice?: number;
  claimPatPrice?: number;
  claimItemCount?: number;
  netPrice?: number;
  claimDate?: Date;
  vatValue?: number;
  pureVat?: number;
  remainingValue?: number
  requestDocId?: number
  billItem?: number
  itemOrServiceCode?: number
  cashCharge?: number
  serviceCoupon?: number
  sharedVat?: number
  regPatServiceSerial?: number
  executedByDocId?: number;
  cshCashierTransDetailSerial?: number;
  itemCount?: number
  discountPrecent?: number;
  comingFrom?: number;
  study_ID?: number;
  fixedConsumerValue?: number

}

export interface ClaimsDetail {
  code: number;
  companyCode: number;
  branchCompanyCode?: number;
  payedValue: number;
  remainingValue?: number;
}
export interface CshClaimPayedPatDetail {
  serial: number
  cshClaimPayedDetailSerial?: number
  cshCashierTransSerial?: number
  billSummaryPatBillSerial?: number
  acrMasterClaimCode?: number
  claimAmmount?: number,
  payedValue: number,
  remainingValue: number
}


export interface SupplierBillsDetail {
  code: number;
  supplierCode: number;
  payedValue: number;
  remainingValue?: number;
  recieptSupplierNotifDiscountValue?: number;
}

export interface ClientBillsDetail {
  code: number;
  clientCode: number;
  payedValue: number;
  remainingValue?: number;
  recieptClientNotifDiscountValue?: number;
}
export interface DocFeesDetail {
  code: number;
  docCode: number;
  payedValue: number;
  remainingValue?: number;
}
export interface hrEmpCalcSalary {
  serial: number;
  empId: number;
  compValue: number;
  remainingValue?: number;
  month?: number;
  year?: number;
}

export interface PayedReceipt {
  cashierTrans: CashierTrans[];
  payedServices: PayedServices[];
  claimsDetail: ClaimsDetail[];
  supplierBillsDetail: SupplierBillsDetail[],
  clientBillsDetail: ClientBillsDetail[],
  docFeesDetail: DocFeesDetail[];
  inOutVariable: InOutVariable[];
  cshDeductionsDetails: CshDeductionsDetails[];
  cshCashierTransCheque: CshCashierTransCheque[];
  cshCashierTransVisa: CshCashierTransVisa[];
  cshCashierSupplierDiscountNotifications: ClaimsMemo[];
  cshCashierClientDiscountNotifications: ClaimsMemo[];
  cshCashierTransCoupon: CshCashierTransCoupon[];
  bankTransformerDetailArray: cshBankTransformerLog[];
  cshClaimPayedPatDetailArray?: CshClaimPayedPatDetail[];
  editbanktransferSader?: cshBankTransformerLog[];
  editbanktransferWard?: cshBankTransformerLog[];
  hrempcalcsalary?: hrEmpCalcSalary[];
  cshSettlement?: CshSettlement[];
}





export interface ModifiedServices {
  payedServices: PayedServices[];
}
//------------------------------------------------------------------------------------------
export interface BillPatChargeList {
  cashierParms: CashierParms;
  billPatServiceCharge: BillPatServiceCharge;
  billPatItemCharge: BillPatItemCharge;
  billPatResidenceCharge: BillPatResidenceCharge;
  therapeuticCards: TherapeuticCards;
  approvals: ApprovalRequest[];
  approvalRequestMaster: ApprovalRequestMaster;
}



export interface BillPatCharge {
  serial?: number;
  visitSerial?: number;
  billItem?: number;
  contractId?: number;
}

export interface BillPatServiceCharge extends BillPatCharge {
  serviceId?: number;
  patSharingPercent?: number;
}

export interface BillPatItemCharge extends BillPatCharge {
  itemCode?: number;
  patSharingPercent?: number;
  price?: number;
  patPrice?: number;
  netPrice?: number;
  sharedPrice?: number;
  vatValue?: number;
  patvat?: number;
  sharedVat?: number;
  realActionDate?: Date;
  count?: number;
  fakeUnit?: number;
}

export interface BillPatResidenceCharge extends BillPatCharge {
  placeCode?: number;
  patSharingPercent?: number;
}
export interface CshVatConsent {
  fromDate: Date,
  toDate: Date

}

//------------------------------------------------------------------------------------------
@Injectable()
export class CashierTransService {
  [x: string]: any;
  constructor(private httpGeneralService: HttpGeneralService, private _MS: GenModuleSettingService
  ) { }

  addCashierTrans(payedReceipt: PayedReceipt) {
    return this.httpGeneralService.add<PayedReceipt>(payedReceipt, cashiertransUrl);
  }
  validateDailyCashier(DailyCashier: CashierTrans) {
    return this.httpGeneralService.add<CashierTrans>(DailyCashier, `${cashiertransUrl}/CshValidateDailyCashier`);
  }
  CshUpadateCashierTrans(payedReceipt: PayedReceipt) {
    return this.httpGeneralService.add<PayedReceipt>(payedReceipt, `${cashiertransUrl}/CshUpadateCashierTrans`);
  }
  GetNotPayedPatients(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/NOtPayedPatients`);
  }
  GetPatientWithOffers(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/PatientWithOffers`);
  }
  GetDetailsAnOffers(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/DetailsAnOffers`);
  }

  CashierTransLoad(cashierParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(cashierParms, `${cashiertransUrl}/CashierTransLoad`);
    //data[0]
  }

  GetNotPayedVisitServices(cashierParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(cashierParms, `${cashiertransUrl}/Services`);
  }

  GetCashierTransById(receiptType: number, receiptSerial: number) {
    return this.httpGeneralService.getWith(`${cashiertransUrl}/Receipts/${receiptType}/${receiptSerial}`);
  }

  GetReceiptsAndPayments(cashierParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(cashierParms, `${cashiertransUrl}/DairyDetail`);
  }
  GetCshReceivingReceipts(cashierParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(cashierParms, `${cashiertransUrl}/GetCshReceivingReceipts`);
  }

  GetReceiptsAndPaymentsWihAllUser(cashierParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(cashierParms, `${cashiertransUrl}/GetReceiptsAndPaymentsWihAllCashir`);
  }

  UpdateVisaDetail(visaDetail: CshCashierTransVisa) {
    return this.httpGeneralService.add<CshCashierTransVisa>(visaDetail, `${cashiertransUrl}/VisaDetail`);
  }

  GetCashierCurrentBalance(currencyCode: number, cashierId?: number) {
    return this.httpGeneralService.getWith(`${cashiertransUrl}/CurrentBalance/${currencyCode}/${cashierId}`);
  }

  GetCompaniesReceipts(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/CompaniesReceipts`);
  }

  GetCompanyReceiptServices(receiptSerial: number) {
    return this.httpGeneralService.get(receiptSerial, `${cashiertransUrl}/CompanyReceiptServices`);
  }

  UpdateCompaniesReceiptServices(modifiedServices: ModifiedServices) {
    return this.httpGeneralService.add<ModifiedServices>(modifiedServices, `${cashiertransUrl}/ModifiedServices`);
  }
  //Nada 25/11/2023 add permission
  GetRemainingDownPayment(benfCode: number, benfType: number, cshCurrencyFactor: number, downPaymentFlag: number, VisitSerial: number = 0, permission: number = 0) {
    return this.httpGeneralService.getWith(`${cashiertransUrl}/RemainingDownPayment/${benfCode}/${benfType}/${cshCurrencyFactor}/${downPaymentFlag}/${VisitSerial}/${permission}`);
  }

  ContractUpdate(billPatChargeList: BillPatChargeList) {
    return this.httpGeneralService.add(billPatChargeList, `${cashiertransUrl}/ContractUpdate`);
  }

  ContractUpdateLoad(cashierParms: CashierParms) {
    return this.httpGeneralService.add(cashierParms, `${cashiertransUrl}/ContractUpdateLoad`);
  }



  GetModifiedServicesAndItems(cashierParms: CashierParms) {
    return this.httpGeneralService.add(cashierParms, `${cashiertransUrl}/ModifiedServicesAndItems`);
  }

  obtCashCheque(cheqesData: CshCashierTransCheque[]) {
    return this.httpGeneralService.addCollection(cheqesData, `${cashiertransUrl}/ObtCashCheques`);
  }

  GetEmpPayRollSummary(cashierParms: CashierParms) {
    return this.httpGeneralService.add(cashierParms, `${cashiertransUrl}/EmpPayRollSummary`);
  }

  GetBeneficiaries(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/Beneficiaries`);
  }
  GetAssets(searchKey: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(searchKey, `${cashiertransUrl}/GetAssets`);
  }
  GetLoanTerms(loanCode: number, cshCurrencyFactor: number, termStatus: number) {
    return this.httpGeneralService.getWith(`${cashiertransUrl}/LoanTerms/${loanCode}/${cshCurrencyFactor}/${termStatus}`);
  }

  CshGetPatientAccountInfo(cashierParms: CashierParms) {
    return this.httpGeneralService.add<CashierParms>(cashierParms, `${cashiertransUrl}/CshGetPatientAccountInfo`);
  }
  CancelOfferService(regPatServices: RegPatService[]) {
    return this.httpGeneralService.addCollection(regPatServices, `${orderingUrl}/CancelOfferService`);
  }

  getStockModuleSettings(parms: StockModuleSettingsParms) {
    return this._MS.getStockModuleSettings(parms);
  }
  updateClosingTransaction(closingTransaction: CshVatConsent) {
    return this.httpGeneralService.add<CshVatConsent>(closingTransaction, `${cashiertransUrl}/updateClosingTransaction`)
  }

  updateContractInCashier(CashierTrans: CashierTrans) {
    return this.httpGeneralService.add<CashierTrans>(CashierTrans, `${cashiertransUrl}/updateContractInCashier`);
  }
  GetCashierTransForFinantialModifing(cashierParms: CashierParms) {
    return this.httpGeneralService.add(cashierParms, `${cashiertransUrl}/GetCashierTransForFinantialModifing`);
  }

  GetReceiptData(CashierParms: CashierParms) {
    return this.httpGeneralService.add(CashierParms, `${cashiertransUrl}/GetReceiptData`);
  }

  AddReceiptStaff(WorkTeamReceipt: any[]) {
    return this.httpGeneralService.addCollection(WorkTeamReceipt, `${cashiertransUrl}/AddReceiptStaff`);
  }
  deleteRegPatServiceStaffDetail(serial: number) {
    return this.httpGeneralService.delete(serial, `${cashiertransUrl}/deleteRegPatServiceStaffDetail`);
  }
  CancelSubCashierReceiving(CashierTrans: CashierTrans[]) {
    return this.httpGeneralService.addCollection(CashierTrans, `${cashiertransUrl}/CancelSubCashierReceiving`);
  }


  updateTransDate(CashierTrans: CashierParms[]) {
    return this.httpGeneralService.add(CashierTrans, `${cashiertransUrl}/updateTransDate`);
  }

}
